import checker from '../components/InteractionChecker';

export default class SoundtrackPlayer {
	constructor(container) {
		this.container = container;
		this.soundtrackTrigger = this.container.querySelector('[data-soundtrack-trigger]');
		this.soundtrackButton = this.container.querySelector('[data-toggle-soundtrack]');
		this.soundtrackButtonMobile = this.container.querySelector('[data-mobile-play-button]');
		this.soundtrackPlayer = this.container.querySelector('[data-soundtrack-audio-player]');
		this.triggered = false;

		this.breakpoint = window.matchMedia('(max-width:767.5px)');

		// Lazy, so i reused this custom event to stop and remove the audio bar when present
		const filmStartEvent = new CustomEvent('filmstart');
		document.dispatchEvent(filmStartEvent);

		this.soundtrackPlayer.addEventListener('play', (e) => {
			this.play();
		});

		this.soundtrackPlayer.addEventListener('pause', (e) => {
			this.stop();
		});

		this.soundtrackPlayer.addEventListener('ended', (e) => {
			this.stop();
		});

		this.soundtrackTrigger.addEventListener('mouseenter', (e) => {
			if (!checker.interacted) {
				return;
			}

			if (this.isPlaying || this.triggered) {
				return;
			}

			this.playFirstTime();
		});

		this.soundtrackButton.addEventListener('click', (e) => {
			this.isPlaying ? this.soundtrackPlayer.pause() : this.soundtrackPlayer.play();
		});

		this.soundtrackButtonMobile.addEventListener(
			'click',
			(e) => {
				this.playFirstTime();
			},
			{
				once: true,
			},
		);

		window.addEventListener(
			'click',
			(e) => {
				if (!this.breakpoint.matches) {
					this.soundtrackButtonMobile.classList.remove('is-active-fallback');
				}
			},
			{
				once: true,
			},
		);

		if (!checker.interacted && !this.breakpoint.matches) {
			this.soundtrackButtonMobile.classList.add('is-active-fallback');
		}

		this.initAnimation();
	}

	get isPlaying() {
		return !this.soundtrackPlayer.paused;
	}

	playFirstTime() {
		this.triggered = true;
		this.soundtrackPlayer.play();
		this.soundtrackButtonMobile.classList.remove('is-active');
		this.soundtrackButton.classList.add('is-active');
	}

	play() {
		this.soundtrackButton.classList.add('is-playing');
		this.startAnimation();
	}

	stop() {
		this.soundtrackButton.classList.remove('is-playing');
		this.stopAnimation();
	}

	createPathString(numberOfLines, lineDataArr) {
		var completedPath = '',
			comma = ','; // pixel range from 0, aka how deeply they bend

		for (var i = 0; i < numberOfLines; i++) {
			var path = lineDataArr[i];

			var ampl = path.ampl;

			var current = {
				x: ampl * Math.sin(path.counter / path.sin),
				y: ampl * Math.cos(path.counter / path.cos),
			};

			var newPathSection =
				'M' +
				// starting point
				path.startX +
				comma +
				path.startY +
				// quadratic control point
				' Q' +
				path.pointX +
				comma +
				(current.y * 2.5).toFixed(3) + // 1.5 to amp up the bend a little
				// center point intersection
				' ' +
				(current.x / 20 + path.centerX).toFixed(3) +
				comma +
				(current.y / 5 + path.centerY).toFixed(3) +
				// end point with quadratic reflection (T) (so the bottom right mirrors the top left)
				' T' +
				path.endX +
				comma +
				path.endY;
			path.counter++;

			completedPath += newPathSection;
		}

		return completedPath;
	}

	createLines(svg, lineCount) {
		var newPathEl = document.createElementNS('http://www.w3.org/2000/svg', 'path'),
			// higher is slower
			minSpeed = 20,
			maxSpeed = 50;

		// create an arr which contains objects for all lines
		// createPathString() will use this array

		let lineDataArr = [];

		for (var i = 0; i < lineCount; i++) {
			var lineDataObj = {
				counter: this.randomRange(1, 800), // a broad counter range ensures lines start at different cycles (will look more random)
				startX: 0,
				startY: 50,
				endX: 200, // viewbox = 200
				endY: 50, // viewbox = 100
				sin: this.randomRange(minSpeed, maxSpeed),
				cos: this.randomRange(minSpeed, maxSpeed),
				pointX: this.randomRange(20, 80),
				centerX: this.randomRange(90, 110),
				centerY: this.randomRange(45, 55),
				ampl: this.randomRange(4, 6),
			};

			lineDataArr.push(lineDataObj);
		}

		var animLoop = () => {
			const pathString = this.createPathString(lineCount, lineDataArr);
			newPathEl.setAttribute('d', pathString);
			requestAnimationFrame(animLoop);
		};

		// once the path elements are created, start the animation loop
		svg.appendChild(newPathEl);
		animLoop();
	}

	randomRange(min, max) {
		return ~~(Math.random() * (max - min + 1)) + min;
	}

	initAnimation() {
		this.graphic = document.querySelector('[data-soundtrack-graphic]');

		this.svgEls = document.querySelectorAll('[data-soundtrack-lines]');
		this.svgEls.forEach((svg) => {
			this.createLines(svg, 2);
		});
	}

	startAnimation() {
		this.graphic.classList.add('v3-ch-soundtrack__graphic--playing');
	}

	stopAnimation() {
		this.graphic.classList.remove('v3-ch-soundtrack__graphic--playing');
	}
}
